module.exports = __webpack_public_path__ + "img/picto-profil.b6ce8dd6.svg";